import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { User } from "../../../user/user";
import {UserSubscription} from "../../../user/user-subscription";
import {Payment} from "../../../user/payment";
import * as fromStore from "../../../store";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../../store";
import {getCurrencySymbol, isCurrencySymbol} from "../../../shared/utils/currency-symbols";
import {CompanyInfo} from "../../../store/actions/company-info.action";

@Component({
    selector: 'db-checkout-summary',
    templateUrl: './checkout-summary.component.html',
    styleUrls: ['./checkout-summary.component.scss'],
    standalone: false
})
export class CheckoutSummaryComponent implements OnInit, OnChanges {

  public isMobile: boolean = false;
  public payments: Payment[];
  public hasPayments: boolean;
  public nextBillingDate: Date;
  public currencySymbol: string = '$';
  public isCurrencyBeforeAmount: boolean = true;
  public loading: boolean;
  @Input() user: User;
  @Input() proRatedCredits: number;
  @Input() currentSubscription: UserSubscription;
  @Input() choosedSubscription: UserSubscription;
  @Input() renew: boolean;
  @Input() companyInfo: CompanyInfo;

  constructor(
    private _store: Store<DbStoreState>
  ) {}

  ngOnInit() {
    this.isMobile = window.innerWidth < 991;
    this._getPayments();
    this._nextBillingDate();
    this._updateCurrencySymbol();
  }

  private _nextBillingDate(): void {
    let today = new Date();
    // Set next billing date based on periodNumber
    const extraDays = Number(this.currentSubscription?.freeDaysBeforePayment) || 0;
    if (this.choosedSubscription?.periodNumber === 1) {
      // Add one month to today's date
      this.nextBillingDate = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + extraDays);
    } else if (this.choosedSubscription?.periodNumber === 12) {
      // Add one year to today's date
      this.nextBillingDate = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate() + extraDays);
    }
  }

  private _getPayments() {
    this._store.select(fromStore.getPaymentsLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getPayments)),
        first()
      )
      .subscribe((payments: Payment[]) => {
        this.payments = payments && payments.filter((payment) => !['failed', 'requires_source_action'].includes(payment.paymentStatus));
        this.hasPayments = !!payments?.length && !this.currentSubscription?.trialBoosterClient;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && (changes['choosedSubscription'])) {
      changes['choosedSubscription'] && (this.choosedSubscription = changes['choosedSubscription'].currentValue);
      this._nextBillingDate();
    }
    if (changes && changes['companyInfo']) {
      this._updateCurrencySymbol();
    }
  }

  private _updateCurrencySymbol(): void {
    this.currencySymbol = getCurrencySymbol(this.companyInfo?.agency?.currency);
    this.isCurrencyBeforeAmount = isCurrencySymbol(this.currencySymbol);
  }

    protected readonly Math = Math;
}





